import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, withRouter } from "react-router-dom";

const mapStateToProps = ({ user }) => {
  return {
    user: user,
  };
};

const Auth = ({ loggedIn, user, path, location, component: Component }) => {
  console.log("Route", user);
  if (user.currentUser && user.isSessionValid) {
    console.log("Route 1.1");
    if (user.currentUser.status === "activated") {
      return (
        <Route
          path={path}
          render={(props) => <Redirect to="/change_password" />}
        />
      );
    } else {
      return (
        <Route path={path} render={(props) => <Redirect to="/contracts" />} />
      );
    }
  } else {
    return <Route path={path} render={(props) => <Component {...props} />} />;
  }
};

const Protected = ({ user, path, location, component: Component }) => {
  return (
    <Route
      path={path}
      render={
        (props) =>
          user.isSessionValid ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: "/login", state: {} }} />
          ) //originalPath:location.pathname||location
      }
    />
  );
};

export const AuthRoute = withRouter(connect(mapStateToProps)(Auth));

export const ProtectedRoute = withRouter(connect(mapStateToProps)(Protected));
